// landing/HeaderSection.jsx
import React from 'react';
import ShelbulaLogo from './ShelbulaLogo';

/* ========================
 * handleScrollTo - Helper function for smooth scrolling
 * ========================*/
const handleScrollTo = (e, id) => {
  e.preventDefault();
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

/* ========================
 * HeaderSection - Displays the navigation header for the landing page
 * Adapts style based on scroll position and provides navigation links/buttons
 * ========================*/
const HeaderSection = ({ scrollPosition, onLoginClick, onSignupClick }) => {
  return (
    <header className={`fixed top-0 left-0 right-0 z-50 py-4 px-6 flex items-center justify-between transition-all duration-300 ${scrollPosition > 50 ? 'bg-gray-950/80 backdrop-blur shadow-md' : ''}`}>
      <ShelbulaLogo />
      
      <div className="hidden md:flex flex-col items-center">
        <nav className="flex items-center space-x-8">
          <a href="#features" onClick={(e) => handleScrollTo(e, 'features')} className="text-gray-300 hover:text-white transition-colors">Features</a>
          <a href="#compare" onClick={(e) => handleScrollTo(e, 'compare')} className="text-gray-300 hover:text-white transition-colors">Pricing</a>
          <a href="#faqs" onClick={(e) => handleScrollTo(e, 'faqs')} className="text-gray-300 hover:text-white transition-colors">FAQs</a>
        </nav>
      </div>
      
      <div className="flex items-center space-x-3">
        <button 
          onClick={onLoginClick}
          className="text-gray-300 hover:text-white px-4 py-2 rounded-lg transition-colors"
        >
          Log in
        </button>
        <button
          onClick={onSignupClick}
          className="bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Sign up
        </button>
      </div>
    </header>
  );
};

export default HeaderSection;